import { getUtid } from 'saddlebag-user-management';

import { getXGatewayServedBy } from '../x-gateway-servedby';

import type { Experiment } from '@shared/types/frontend/ubff/hotel-unified-bff';
import type { Device, UserContext } from '@shared/types/user-context';

import { X_GATEWAY_SERVED_BY } from '@shared/constants/x-gateway-servedby';
import { getCurrentQueryParam } from '@shared/utils-frontend/url/url';
import { buildCommonUBFFHeaders } from '@shared/utils-universal/ubff-headers';

export {
  buildTravellerContext,
  buildPartnerSortingContext,
  buildHopsVersion,
  buildHighlightHotels,
} from '@shared/utils-universal/ubff-params';

export const getCommonHeaders = ({
  device,
  fromCashBack,
  impressionId,
  ipAddress,
  isWebView,
}: {
  device: Device;
  impressionId: string;
  ipAddress: string;
  isWebView: boolean;
  fromCashBack?: boolean;
}) => {
  const source = getCurrentQueryParam('source');
  const overrideFeatureTest = getCurrentQueryParam('OverrideFeatureTest');
  const overrideConfig = getCurrentQueryParam('OverrideConfig');

  const headers = buildCommonUBFFHeaders({
    device,
    ipAddress,
    isWebView,
    utid: getUtid(),
    source,
    impressionId,
    overrideFeatureTest,
    overrideConfig,
    fromCashBack,
  });

  const xGatewayServedBy = getXGatewayServedBy();
  if (xGatewayServedBy) {
    headers[X_GATEWAY_SERVED_BY] = xGatewayServedBy;
  }

  return headers;
};

export const buildExperiments = (userContext: UserContext) => {
  const { experiments } = userContext;
  const newExperimentList: Experiment[] = [];
  Object.entries(experiments).forEach(([key, value]) => {
    if (value) {
      const newObj = {
        name: key,
        variant: value,
      };
      newExperimentList.push(newObj);
    }
  });

  return newExperimentList;
};
